import { Box, Modal } from 'app/components/design-system-components'

function IncorrectDocumentReuploadModal({
  toggleModal = () => {},
  primaryAction = () => {},
  secondaryAction = () => {},
}) {
  const modalBody = (
    <Box mt={4} mb={0} lineHeight="140%">
      It looks like the uploaded document might not be a Payslip. Would you like
      to remove an add a different document?
    </Box>
  )
  return (
    <Modal
      modalHeading="Correct Document?"
      modalBody={modalBody}
      modalFooter={undefined}
      primaryLabel="Remove and reupload"
      primaryAction={primaryAction}
      secondaryLabel="Continue"
      secondaryAction={secondaryAction}
      toggleModal={toggleModal}
    />
  )
}

export default IncorrectDocumentReuploadModal
